import { createContext } from 'react'

const rudderStackInital = {
  rudderStackLoaded: false,
  analyticsConsentGranted: false,
}

const RudderStackContext = createContext(rudderStackInital)

export default RudderStackContext
